import { render, staticRenderFns } from "./AdminSocietes.vue?vue&type=template&id=47e2d76e"
import script from "./AdminSocietes.vue?vue&type=script&lang=js"
export * from "./AdminSocietes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports